module.exports = __webpack_public_path__ + "rovcanin_rvcnn_facebook_cover_fashion_design_beautiful_pink_jewellry_girls.jpg?798dfdf0cb7aa0acfd810316081f0d4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/rovcanin_rvcnn_facebook_cover_fashion_design_beautiful_pink_jewellry_girls.jpg
// module id = 99
// module chunks = 0